import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import styles from "./Customer.module.scss";
import AddCustomerModal from "./AddCustomerModal";
import { Button } from "@mui/material";
import useAddCustomer from "./hooks";
import MUIModal from "../../components/MUIModal";
import ProgressLoader from "../../components/ProgressLoader/ProgressLoader";
import CustomerDataTable from "./CustomerDataTable";

const Customers = () => {
	const {
		reset,
		register,
		watch,
		handleSubmit,
		setValue,
		control,
		errors,
		showModal,
		disableSubmit,
		currentData,
		customersData,
		onSubmit,
		setCurrentData,
		setShowModal,
		isLoading,
		isFetching,
	} = useAddCustomer();

	return (
		<div className={styles.orderArea}>
			<div className={styles.orderTop}>
				<Button
					variant="contained"
					onClick={() => {
						setCurrentData(null);
						reset();
						setShowModal(true);
					}}
					size="small"
					startIcon={<FontAwesomeIcon icon={faPlus} />}
				>
					Add Customer
				</Button>
			</div>

			{isLoading || isFetching ? (
				<ProgressLoader horPosition="flex-start" />
			) : (
				<CustomerDataTable
					customers={customersData ? customersData.customers : []}
					loading={isLoading}
				/>
			)}

			<form onSubmit={handleSubmit(onSubmit)}>
				<MUIModal
					showModal={showModal}
					setShowModal={setShowModal}
					modalTitle={`${currentData ? "Update" : "Add"} Customer`}
					closeBtn="Cancel"
					secondaryBtnText={currentData ? "Update" : "Submit"}
					secondaryBtnDisabled={disableSubmit}
					handleClickSecondaryBtn={handleSubmit(onSubmit)}
					isSubmit={true}
					modalClassName="wd-65"
					modalBodyComponent={
						<AddCustomerModal
							setValue={setValue}
							currentData={currentData}
							register={register}
							errors={errors}
							watch={watch}
							control={control}
						/>
					}
				/>
			</form>
		</div>
	);
};

export default Customers;
